/* eslint-disable import/first */
import React, { useState } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useDispatch } = Redux;
import { Grid, TextField, Button } from '@material-ui/core';
import { MobileNumberInput } from './MobileNumberInput';
const { editPro } = Slices.profileSlice;
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from '@reach/router';
import { createMuiTheme, ThemeProvider, StylesProvider, jssPreset } from '@material-ui/core/styles';
import { create } from 'jss';
import { allowedCountry } from 'spwa-ui-library/esm/utils/helper';
import { Check } from '../../components/Icons';
import rtl from 'jss-rtl';
import Cookies from 'js-cookie';
import css from './index.module.scss';

const EditProfileCard = ({ profile, isEditMode }) => {
  const profileData = profile?.data?.data;
  const name = profileData?.[0]?.name;
  const phnNo = profileData?.[0]?.phnNo;
  const email = profileData?.[0]?.email;
  const [profileName, setProfileName] = useState(name);
  const [profilephnNo, setProfilePhnNo] = useState(phnNo);
  const [profileemail, setProfileEmail] = useState(email);
  const [errBool, setErrBool] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const dispatch = useDispatch();

  const ltrTheme = createMuiTheme({ direction: 'ltr' });
  const rtlTheme = createMuiTheme({ direction: 'rtl' });
  const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
  const [isRtl] = React.useState(Cookies.get('local') === 'ar' ? rtlTheme : ltrTheme);
  const location = useLocation();
  const navigate = useNavigate();

  const onChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'name':
        setProfileName(value.replace(/[^a-zA-Z ]/g, ''));
        validationName(value.replace(/[^a-zA-Z ]/g, ''));
        break;
      case 'email':
        setProfileEmail(value);
        break;
      case 'mobile':
        setProfilePhnNo(value);
        break;

      default:
        break;
    }
  };

  const validationName = (nameInput) => {
    let name = nameInput;
    var pattern = /^(?:[a-zA-Z\s\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDCF\uFDF0-\uFDFF\uFE70-\uFEFF]|(?:\uD802[\uDE60-\uDE9F]|\uD83B[\uDE00-\uDEFF])){0,30}$/;
    if (name.match(pattern)) {
      setErrBool(false);
    } else {
      setErrBool(true);
    }
    // eslint:fix == is replaced with ===
    if (name === '') {
      setErrBool(true);
    }
  };

  const submitEdit = () => {
    dispatch(editPro({ name: profileName, phnNo: profilephnNo, email: profileemail }))
      .then((res) => {
        if (res?.error) {
          setErrorMsg(res?.error.message);
        } else {
          setErrorMsg('');
          isEditMode((prev) => false);
          location.state.fromPage === 'checkout' && navigate(-1, { replace: true });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEdit = () => {
    isEditMode(false);
    location.state.fromPage === 'checkout' && navigate(-1, { replace: true });
  };

  return (
    <>
      <Grid className={css.profileCardArea}>
        <StylesProvider jss={jss}>
          <ThemeProvider theme={isRtl}>
            <Grid className={css.inputArea}>
              <>
                <TextField
                  fullWidth
                  required
                  id="outlined-required"
                  name="name"
                  label={<FormattedMessage id="nameCaps" defaultMessage="Name" />}
                  value={profileName || ''}
                  defaultValue={profileName}
                  inputProps={{ maxLength: 40 }}
                  onChange={onChange}
                />
              </>
            </Grid>
            {errBool && (
              <Grid className={css.warningText}>
                <FormattedMessage id="name_validate" defaultMessage="Please Enter a valid Name" />
              </Grid>
            )}
            <Grid container alignItems="center" className={css.emailArea}>
              <Grid item xs>
                <Grid className={css.inputArea}>
                  <TextField
                    // disabled
                    fullWidth
                    required
                    name={<FormattedMessage id="email" defaultMessage="Email" />}
                    id="outlined-required"
                    label={<FormattedMessage id="emailUpper" defaultMessage="Email" />}
                    type="email"
                    value={profileemail}
                    onChange={onChange}
                    className={css.editEmailField}
                  />
                </Grid>
              </Grid>

              {profileData?.[0]?.emailVerified ? (
                <div className={css.check}>
                  <Check />
                </div>
              ) : (
                ''
              )}
            </Grid>{' '}
            {profileData.map((el) => {
              const isAllowCountry = allowedCountry(el.country) && el.country === profile.country;
              if (!isAllowCountry) return '';

              return (
                <Grid className={css.inputArea}>
                  <Grid className={css.mobileIoArea}>
                    <MobileNumberInput
                      phoneVerified={el.phnVerified ? 1 : 0}
                      showCountryDropDown={false}
                      countryCode={el.cCode}
                      value={el.phnNo}
                      onChange={onChange}
                      hideName={true}
                      overrideCountry={el.country}
                    />
                  </Grid>
                </Grid>
              );
            })}
          </ThemeProvider>
        </StylesProvider>
        {errorMsg !== '' ? <div className={css.errorNotification}>Something went Wrong</div> : ''}
      </Grid>
      <Grid className={css.buttonArea}>
        <Button variant="outlined" className={css.cancelButton} onClick={handleEdit}>
          <FormattedMessage id="cart_cancel" defaultMessage="Cancel" />
        </Button>
        <Button
          disabled={errBool}
          variant="contained"
          color="primary"
          className={!errBool ? css.saveButton : css.disableSaveButton}
          onClick={submitEdit}
        >
          <FormattedMessage id="createprofile_save" defaultMessage="Save" />
        </Button>
      </Grid>
    </>
  );
};
export default EditProfileCard;
